import { keysToCamelCase } from '@hotjar/webapp/lib/convert-string';
import axios from 'axios';
import type { RegistrationCampaign } from './model';
import type { RegistrationCampaignDto } from './dto';
import { mapResponseErrorToMessage } from '../common/api';

const API_ROOT = `/api/v1/campaigns`;

export const DEFAULT_REGISTRATION_PLAN = 'basic';

export const getRegistrationCampaign = async (
  campaignId: string,
): Promise<RegistrationCampaign> => {
  try {
    const response = await axios.get<RegistrationCampaignDto>(`${API_ROOT}/${campaignId}`);
    const { ...campaignDetails } = response.data;

    return {
      valid: campaignDetails.enabled,
      hash: campaignId,
      plan: campaignDetails.enabled ? campaignDetails.plan : DEFAULT_REGISTRATION_PLAN,
      details: keysToCamelCase(campaignDetails),
    };
  } catch (error) {
    return { valid: false, plan: DEFAULT_REGISTRATION_PLAN, hash: campaignId };
  }
};

interface ApplyCampaign {
  campaignId: string;
  accountId: string;
}

export interface ApplyCampainResponse {
  success: boolean;
  // eslint-disable-next-line camelcase
  campaign_type: string;
  message: string;
}

export async function applyCampaignToAccount({
  campaignId,
  accountId,
}: ApplyCampaign): Promise<ApplyCampainResponse> {
  const response = await axios.post<ApplyCampainResponse>(
    `api/v1/accounts/${accountId}/campaigns`,
    {
      campaign_hash: campaignId,
    },
  );

  if (!response.data.success) {
    throw new Error(mapResponseErrorToMessage(response.data.message));
  }

  return response.data;
}
